import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import ActiveCompanyUtils from '@_utils/router/active-company.utils';

@Injectable()
export class CompanyInterceptor implements HttpInterceptor {
  private avalaibleRoute: string[] = ['api/dashboard/activity'];

  public intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    if (request.method !== 'GET' || !this.checkIfRequestNeedCompanies(request.urlWithParams)) {
      return next.handle(request);
    }
    // const formatedObject=ActiveCompanyUtils.getActiveCompaniesForRequest();
    //     formatedObject[key].forEach(element => {
    //       params = params.append(`${key}[]`, element);
    //     });
    const newRequest = request.clone({
      setParams: { ['idsCompanies[]']: ActiveCompanyUtils.getActiveCompaniesForRequest().toString() }
    });
    return next.handle(newRequest);
  }
  private checkIfRequestNeedCompanies(url: string): boolean {
    return this.avalaibleRoute.some(route => url.includes(route));
  }
}
